import {visibilityEffect} from "@dp-instant/ui";
import {UIConstants} from "@game/ui/constants";
import {playUIClickSound} from "@game/helpers";
import {Images} from "@game/ui/images";
import cn from "classnames";
import "./ReferralGiftPopup.less";

type ReferralGiftPopupProps = {
    onConfirm: () => void;
};

export const ReferralGiftPopup = ({onConfirm}: ReferralGiftPopupProps) => {
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);

    return (
        <div className="popups">
            <div className={cn("popup-referral-gift", {invisible})}>
                <div className="popup-referral-gift__emoji">🎁</div>
                <div className="popup-referral-gift__title">Welcome Gift!</div>
                <div className="popup-referral-gift__amount">
                    +25 <Images.Star />
                </div>
                <button
                    className="popup-referral-gift__btn"
                    onClick={() => { playUIClickSound(); onConfirm(); }}
                >
                    OK
                </button>
            </div>
        </div>
    );
};
